import {
    clearFreshNonceCache,
    fetchFreshNonce,
    getNonce,
    isAuthOrPermissionFailure,
    isWpAjaxNonceFailure,
} from "../services/nonce";
import {getAjaxUrl} from "../services/site-vars";

const get_ajax_url = getAjaxUrl;
const get_nonce = getNonce;
const fetch_fresh_nonce = fetchFreshNonce;
const clear_fresh_nonce_cache = clearFreshNonceCache;
const is_auth_or_permission_failure = isAuthOrPermissionFailure;
const is_wp_ajax_nonce_failure = isWpAjaxNonceFailure;

export {
    clear_fresh_nonce_cache,
    fetch_fresh_nonce,
    get_ajax_url,
    get_nonce,
    is_auth_or_permission_failure,
    is_wp_ajax_nonce_failure,
};
